import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isAgent } from './isAgent';
import { isFromBuilder } from './agent/isFromBuilder';
import { isFromSeller } from './agent/isFromSeller';
import { isPro } from './agent/isPro';

export const isProAgent: TComputedPropMapper<boolean> = (...args) => {
  return isAgent(...args) && isPro(...args) && !(isFromBuilder(...args) || isFromSeller(...args));
};
